import React from 'react';
import Countdown from 'react-countdown';

const CountdownTimer = () => {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>We are live!</span>;
    } else {
        return <span>{days} days until launch</span>;
    //  return <span>{days}d {hours}h {minutes}m {seconds}s</span>;
    }
  };

  const targetDate = new Date('April 5, 2024 00:00:00');

  return (
    <Countdown date={targetDate} renderer={renderer} />
  );
};

export default CountdownTimer;
